export default {
    install(app, options) {
        app.config.globalProperties.$getValidationErrors = (exception) => {
            return exception.response.data.errors
                ? exception.response.data.errors
                : {};
        };
    }
}